import React from 'react';

export default class UserIcon extends React.Component {
    constructor(props) {
        super(props);
        this.loadSvg();
        this.setIconElement();
    }

    loadSvg() {
        this.iconSvg = '<!--! Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/>';
    }

    setIconElement() {
        const styles = this.props?.style || {};
        const width = this.props?.width || 12;
        const height = this.props?.height || 12;
        if (!styles?.width) {
            styles.width = `${width}px`;
        }
        if (!styles?.height) {
            styles.height = `${height}px`;
        }
        this.iconElement = (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={width} height={height} style={styles} dangerouslySetInnerHTML={{ __html: this.iconSvg }}></svg>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props?.style === prevProps?.style && this.props?.width === prevProps?.width && this.props?.height === prevProps?.height) {
            return;
        }
        this.setIconElement();
    }

    render() {
        return this.iconElement;
    }
}
